import suiEnterprise from '@splunk/themes/enterprise';
import suiEnterpriseDark from '@splunk/themes/enterpriseDark';
import scpTheme from '@splunk/themes/scp';

// we may provide our dashboard specific variables here.

export const enterprise = {
    ...suiEnterprise,
    headerTextColor: suiEnterprise.textColor,
    colorPickerBorderColor: suiEnterprise.gray80,
    dashboardBackgroundColor: suiEnterprise.gray96,
    panelBackgroundColor: suiEnterprise.backgroundColor,
    layoutItemBgColor: suiEnterprise.backgroundColor,
    layoutMenuBgColor: suiEnterprise.backgroundColor,
    layoutMenuHoverBgColor: suiEnterprise.backgroundColorHover,
    layoutBackgroundColor: suiEnterprise.gray96,
    inputHoverBackgroundColor: suiEnterprise.gray96,
    invalidDropTargetBackgroundColor: '#8A393B',
    validDropTargetBackgroundColor: '#80EC9F',
    invalidDropTargetBorderColor: '#FE3A3A',
    validDropTargetBorderColor: '#07BA39',
};
export const enterpriseDark = {
    ...suiEnterpriseDark,
    headerTextColor: suiEnterpriseDark.textColor,
    colorPickerBorderColor: suiEnterpriseDark.gray20,
    // Custom color: gray30 is the same color as a disabled button, and backgroundColor won't provide contrast with sidebar
    dashboardBackgroundColor: '#363D45',
    panelBackgroundColor: suiEnterpriseDark.backgroundColor,
    layoutItemBgColor: suiEnterpriseDark.backgroundColor,
    layoutMenuBgColor: suiEnterpriseDark.backgroundColor,
    layoutMenuHoverBgColor: suiEnterpriseDark.backgroundColorHover,
    layoutBackgroundColor: '#363D45',
    inputHoverBackgroundColor: suiEnterpriseDark.gray45,
    invalidDropTargetBackgroundColor: '#8A393B',
    validDropTargetBackgroundColor: '#117E32',
    invalidDropTargetBorderColor: '#FE3A3A',
    validDropTargetBorderColor: '#08E045',
};
export const scp = {
    ...scpTheme,
    headerTextColor: scpTheme.gray96, // use white 2 for heading
    colorPickerBorderColor: scpTheme.gray20,
    dashboardBackgroundColor: scpTheme.backgroundColor,
    panelBackgroundColor: '#0B0C0E',
    popoverBackgroundColor: scpTheme.gray20,
    layoutItemBgColor: scpTheme.backgroundColor,
    layoutMenuBgColor: scpTheme.backgroundColor,
    layoutMenuHoverBgColor: scpTheme.backgroundColorHover,
    layoutBackgroundColor: scpTheme.backgroundColor,
    inputHoverBackgroundColor: scpTheme.gray17,
    invalidDropTargetBackgroundColor: '#8A393B',
    validDropTargetBackgroundColor: '#117E32',
    invalidDropTargetBorderColor: scpTheme.errorColor,
    validDropTargetBorderColor: scpTheme.green1,
};
